import * as React from 'react';

import classNames from 'classnames';
import { roundedHumanFormat } from '~/libs/Price/Price';

import type { VirtualPackErpResponse } from 'com.cogvio.pricemonitor.api';

const calculateModelSumPrices = (model: VirtualPackErpResponse | null | undefined) =>
	model?.monthData.reduce(
		(sum: null | number, monthData) => (monthData.price.value ? Number(sum || 0) + Number(monthData.price.value) : sum),
		null
	) || NaN;

export const calculateModelAverage = (model: VirtualPackErpResponse | null | undefined) => {
	const modePriceSum = calculateModelSumPrices(model);

	return !isNaN(modePriceSum) ? modePriceSum / (model?.monthData?.length || 0) : NaN;
};

export const renderModelAverage = (model: VirtualPackErpResponse | null | undefined, currency: string) => {
	const revenueAverage = calculateModelAverage(model);

	return !isNaN(revenueAverage) ? `${roundedHumanFormat(currency, String(revenueAverage))} / SKU` : 'NaN';
};

const ERPAveragePriceBadge = ({
	currency,
	erpModelResult,
	type,
}: {
	currency: string;
	erpModelResult?: VirtualPackErpResponse | null;
	type?: 'big' | 'small';
}) => {
	const average = React.useMemo(() => renderModelAverage(erpModelResult, currency), [erpModelResult, currency]);

	return (
		<span
			className={classNames(
				'mr-1 mb-0.5 inline-block px-3 py-1 rounded-sm font-display text-label font-medium leading-5 text-gray-800 tracking-wider bg-cBlue-400 bg-opacity-10',
				{
					'text-label': !type || type === 'big',
					'text-labelsmall': type === 'small',
				}
			)}
		>
			AVG price (in 4Y): <strong className='font-semibold tabular-nums'>{average}</strong>
		</span>
	);
};

export default React.memo(ERPAveragePriceBadge);
